import React from 'react';
import { Box, Typography } from '@mui/material';
import { SmartToy as BotIcon, Person as PersonIcon } from '@mui/icons-material';
import AssistantMessageBody from './AssistantMessageBody';

const ChatMessageBubble = ({ role, text, structured }) => {
  const isUser = role === 'user';
  const showStructured =
    !isUser &&
    structured &&
    (structured.showUrgencyChip ||
      structured.showExplanation ||
      structured.showWhy ||
      structured.showSteps ||
      structured.steps?.length > 0 ||
      structured.urgency ||
      structured.explanation ||
      structured.why_it_matters);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        alignItems: 'flex-end',
        gap: 0.5,
      }}
    >
      {!isUser && <BotIcon fontSize="small" color="primary" sx={{ mb: 0.3, flexShrink: 0 }} />}
      <Box
        sx={{
          maxWidth: '82%',
          px: 1.5,
          py: 1.1,
          borderRadius: isUser ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
          bgcolor: isUser ? '#18B89A' : 'rgba(22, 35, 58, 0.95)',
          color: isUser ? '#04211D' : '#E6EDF7',
        }}
      >
        {isUser || !showStructured ? (
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {text}
          </Typography>
        ) : (
          <AssistantMessageBody text={text} structured={structured} />
        )}
      </Box>
      {isUser && <PersonIcon fontSize="small" color="action" sx={{ mb: 0.3, flexShrink: 0 }} />}
    </Box>
  );
};

export default ChatMessageBubble;
